import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvestmentService } from '../../core/services/api/investment.service';

@Component({
    selector: 'app-thank-you-redirection',
    template: '',
    standalone: false
})
export class ThankYouRedirectionComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private investmentService: InvestmentService,
  ) {}

  ngOnInit(): void {
    const qp = this.route.snapshot.queryParams || {};
    const paymentReferenceNo: string = qp['ref'] || qp['paymentReferenceNo'];
    const campaignStatus: string = qp['campaignStatus'];
    const slugFromQuery: string = qp['campaignSlug'] || qp['slug'];

    // If slug already provided, redirect immediately
    if (slugFromQuery) {
      this.router.navigate(['/equity', slugFromQuery, 'thank-you'], {
        queryParams: {
          ref: paymentReferenceNo,
          paymentReferenceNo: paymentReferenceNo,
          campaignStatus: campaignStatus,
        },
      });
      return;
    }

    // Resolve slug via investmentRef if available
    if (paymentReferenceNo) {
      this.investmentService.getInvestmentDetail(paymentReferenceNo).subscribe({
        next: (data: any) => {
          const slug = data?.campaign?.slug;
          const status = campaignStatus || data?.campaign?.campaignStatus;
          if (slug) {
            this.router.navigate(['/equity', slug, 'thank-you'], {
              queryParams: {
                ref: paymentReferenceNo,
                paymentReferenceNo: paymentReferenceNo,
                campaignStatus: status,
              },
            });
          } else {
            this.router.navigate(['/equity'], {
              queryParams: { ref: paymentReferenceNo, campaignStatus: status },
            });
          }
        },
        error: () => {
          this.router.navigate(['/equity'], {
            queryParams: { ref: paymentReferenceNo, campaignStatus: campaignStatus },
          });
        },
      });
      return;
    }

    // Fallback: no ref and no slug -> go to equity listing
    this.router.navigate(['/equity']);
  }
}